const profileSectionConstants = {
  geoLocation: {
    es: 'Ubicación',
    pt: 'Localização',
  },
};

export default profileSectionConstants;
